import React from 'react';

import styles from './CheckboxGroup.module.scss';

const CheckboxGroup = ({ children }: { children: React.ReactElement | React.ReactNode }) => {
  return <div className={styles.checkboxGroup}>{children}</div>;
};

export default CheckboxGroup;
